import React from 'react';
import { Button, Dropdown } from 'antd';
import moment from 'moment';
import { assetPreviewThumbnails } from '@helpers/assetPreviewThumbnails';
import { AssetVersionItemDto } from '@api/Api';
import Loader from '@components/Loader';
import { ArrowDownIcon, CheckIcon, MediaViewerCommentsIcon } from '@icons';

import './DropdownVersion.less';

type DropdownVersionProps = {
  versions: AssetVersionItemDto[];
  selectedVersion: AssetVersionItemDto;
  commentCount: number;
  canReadComment: boolean;
  onChangeVersion(version: AssetVersionItemDto): void;
  toggleOpenComments(): void;
};

type RenderVersionsMenuItemsProps = {
  versions: AssetVersionItemDto[];
  onChangeVersion(version: AssetVersionItemDto): void;
};

function renderVersionsMenuItems({
  versions,
  onChangeVersion
}: RenderVersionsMenuItemsProps) {
  const preparePreview = (asset: AssetVersionItemDto) =>
    assetPreviewThumbnails({
      url: asset.metadata.preview?.url || '',
      status: asset.metadata.preview?.status || '',
      type: asset.metadata.type || ''
    });
  return versions.map((item) => {
    const { id, name, createdAt, versionNumber } = item;
    const date = moment(new Date(createdAt)).format(
      moment(createdAt).minutes() === 59 ? 'MMM DD' : 'MMM DD, h:mma'
    );
    return {
      label: (
        <div
          key={id}
          className="compare-versions_dropdown-menu-item"
          onClick={() => {
            onChangeVersion(item);
          }}
        >
          <div className="compare-versions_dropdown-menu-image">
            {preparePreview(item) === 'pending' && (
              <Loader
                classNameWrapper="assets-loader-wrapper"
                spinSize={24}
                isSpinning={true}
              />
            )}
            {preparePreview(item) !== 'pending' &&
            typeof preparePreview(item) === 'string' ? (
              <img
                src={`${preparePreview(item)}`}
                alt=""
                className="assets_user_image"
              />
            ) : (
              preparePreview(item)
            )}
          </div>
          <div className="compare-versions_dropdown-menu-content">
            <div className="compare-versions_dropdown-menu-top">
              <div className="compare-versions_dropdown-menu-name">{name}</div>
              <div className="compare-versions_dropdown-menu-label">
                V{versionNumber}
              </div>
              <CheckIcon className="check-svg" />
            </div>
            <div className="compare-versions_dropdown-menu-date">{date}</div>
          </div>
        </div>
      ),
      key: item.id
    };
  });
}

function DropdownVersion({
  versions,
  selectedVersion,
  commentCount,
  canReadComment,
  onChangeVersion,
  toggleOpenComments
}: DropdownVersionProps) {
  const handlerChangeVersion = (newVersion: AssetVersionItemDto) => {
    if (selectedVersion?.id === newVersion?.id) return;
    onChangeVersion(newVersion);
  };

  if (!versions?.length) return null;
  return (
    <div className="compare-versions_dropdown">
      <Dropdown
        menu={{
          className: 'compare-versions_dropdown-menu',
          selectedKeys: [selectedVersion.id],
          items: renderVersionsMenuItems({
            versions,
            onChangeVersion: handlerChangeVersion
          })
        }}
        overlayClassName="compare-versions_dropdown-overlay"
        placement="bottomLeft"
        trigger={['click']}
      >
        <Button
          className="compare-versions-modal_btn"
          icon={<ArrowDownIcon />}
        >
          Version {selectedVersion?.versionNumber}
        </Button>
      </Dropdown>
      {canReadComment && (
        <Button
          className="compare-versions-modal_btn"
          icon={<MediaViewerCommentsIcon />}
          onClick={toggleOpenComments}
        >
          {!!commentCount && commentCount}
        </Button>
      )}
    </div>
  );
}

export default DropdownVersion;
